var Schema = /** @class */ (function () {
    function Schema(_a) {
        var id = _a.id, datasourceId = _a.datasourceId, name = _a.name, columns = _a.columns;
        this.id = id;
        this.datasourceId = datasourceId;
        this.name = name;
        this.columns = columns;
    }
    Schema.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, datasource_id = _a.datasource_id, name = _a.name, columns = _a.columns;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof datasource_id !== 'number')
            throw new Error('datasource_id must be a number');
        if (typeof name !== 'string')
            throw new Error('name must be a string');
        return new Schema({
            id: id,
            datasourceId: datasource_id,
            name: name,
            columns: columns,
        });
    };
    return Schema;
}());
export default Schema;
